import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=ff7c3976&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=ff7c3976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7c3976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7c3976')) {
      api.createRecord('ff7c3976', component.options)
    } else {
      api.reload('ff7c3976', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=ff7c3976&scoped=true&", function () {
      api.rerender('ff7c3976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Promotion/Pagination.vue"
export default component.exports